import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Eye, Clock, TrendingUp, Activity } from 'lucide-react';
import { AnalyticsData } from '../types';

interface MetricsCardsProps {
  analyticsData: AnalyticsData | null;
}

const MetricsCards: React.FC<MetricsCardsProps> = ({ analyticsData }) => {
  // Format time on page
  const formatTimeOnPage = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  // Format number with commas
  const formatNumber = (num: number) => {
    return num.toLocaleString();
  };

  const metrics = [
    {
      name: 'Visitors',
      value: formatNumber(analyticsData?.visitors || 0),
      icon: Users,
    },
    {
      name: 'Page Views',
      value: formatNumber(analyticsData?.pageViews || 0),
      icon: Eye,
    },
    {
      name: 'Sessions',
      value: formatNumber(analyticsData?.sessions || 0),
      icon: Activity,
    },
    {
      name: 'Time on Page',
      value: formatTimeOnPage(analyticsData?.timeOnPage || 0),
      icon: Clock,
    },
    {
      name: 'Bounce Rate',
      value: `${(analyticsData?.bounceRate || 0).toFixed(1)}%`,
      icon: TrendingUp,
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <Card key={metric.name}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{metric.name}</CardTitle>
              <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{metric.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default MetricsCards;
